import { CTAButton } from "@/components/ui/cta-button";

interface ProCTAProps {
  onShowWaitlist?: () => void;
}

export const ProCTA = ({ onShowWaitlist }: ProCTAProps) => {
  const handleClick = () => {
    if (onShowWaitlist) {
      onShowWaitlist();
    }
  };

  return (
    <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
      <div className="container max-w-4xl mx-auto px-4">
        <div className="bg-white rounded-2xl p-4 sm:p-8 shadow-lg border border-gray-100">
          <h2 className="text-2xl sm:text-3xl font-bold text-center mb-8 text-primary">
            Rejoignez-nous si :
          </h2>
          <div className="space-y-6 mb-8">
            <p className="text-base sm:text-lg leading-relaxed pl-4 border-l-4 border-primary/20">
              Que vous soyez débordé ou que votre téléphone prenne la poussière, on vous simplifie la vie
            </p>
            <p className="text-base sm:text-lg leading-relaxed pl-4 border-l-4 border-primary/20">
              Votre gîte a plus de trous dans l'emploi du temps que le fromage de l'Aisne.
            </p>
            <p className="text-base sm:text-lg leading-relaxed pl-4 border-l-4 border-primary/20">
              Vos événements méritent plus de monde que tonton Marcel et ses potes.
            </p>
          </div>
          <p className="text-lg sm:text-xl font-semibold text-center text-secondary mb-8">
            On automatise, vous profitez.
          </p>
          <div className="text-center">
            <CTAButton
              onClick={handleClick}
              mobileText={
                <>
                  Premier arrivé,<br />
                  premier servi…<br />
                  Et SANS commission !
                </>
              }
              desktopText="Premier arrivé, premier servi… Et SANS commission !"
            />
          </div>
        </div>
      </div>
    </section>
  );
};